// extracted by mini-css-extract-plugin
export default {"chip":"UpgradeChip_chip__fYLCF","chip--overlay":"UpgradeChip_chip--overlay__+8j49","chip--inline":"UpgradeChip_chip--inline__rU+OM"};